
angular.module('dpw.components')
    /**
     * @ngdoc directive
     * @name dpwRadio
     * @restrict EA
     * @description
     * Radio Button Wrapper.
     * @param {String} name
     * @param {String} forId
     * @param {String} text
     * @param {expression} model
     * @param {expression} value
     * @param {expression} required
     * @param {expression} isDisabled
     * @param {Function} change
     * @example
     * <dpw-radio name="foo" for-id="bar" text="Foo"
     *            model="$ctrl.foo" value="'foo'"
     *            required="$ctrl.isRequired"
     *            is-disabled="$ctrl.fooDisabled">
     * </dpw-radio>
     */
    .directive('dpwRadio', [function () {
        return {
            restrict: 'EA',
            scope: {
                forId: '@',
                model: '=',
                text: '@',
                isDisabled: '=',
                name: '@',
                value: '=',
                required: '=',
                change: '&'
            },
            templateUrl: 'dpw-radio.html'
        };
    }]);
